export default __webpack_public_path__ + "static/media/users-grey.6e739cc0.svg";